import request from '@/utils/request'

const baseURL = process.env.NODE_ENV === 'production' ? 'https://im-state.zhihuishu.com/' : '/test'

/**
 * @description: 各个终端,服务,从状态机中获取直播相关数据
 * @param {*} params
 * @return {*}
 */
const getLiveInfoGlobal = params => {
  return request({
    baseURL,
    url: `/liveinfo/get`,
    method: 'get',
    params
  })
}

/**
 * @description: 各个终端,服务,从状态机中获取直播设备相关数据
 * @param {*} params
 * @return {*}
 */
 const getClassRoomListGlobal = params => {
  return request({
    baseURL,
    url: `/device/get`,
    method: 'get',
    params
  })
}

export default {
  getLiveInfoGlobal,
  getClassRoomListGlobal
}
